import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';

var dot = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__dot",
  componentId: "sc-1boclke-0"
})(["position:relative;display:inline-block;cursor:", ";", " &:before{position:absolute;top:50%;left:50%;content:'';border-radius:50%;background-color:", ";", " transform-origin:center;transition:background-color ", ",transform ", ";transition-timing-function:", ";will-change:transform;}"], function (_ref) {
  var $controlled = _ref.$controlled,
    $disabled = _ref.$disabled;
  return $controlled && $disabled ? 'not-allowed' : $controlled && !$disabled ? 'pointer' : 'initial';
}, function (props) {
  var activeSize = px2rem(props.$activeSize);
  var inactiveSize = px2rem(props.$size);
  var smallGap = px2rem(2);
  var largeGap = px2rem(8);
  var activeHeightCalc = "calc(".concat(activeSize, " + ").concat(props.$vertical ? largeGap : smallGap, ")");
  var activeWidthCalc = "calc(".concat(activeSize, " + ").concat(props.$vertical ? smallGap : largeGap, ")");
  var inactiveHeightCalc = "calc(".concat(inactiveSize, " + ").concat(props.$vertical ? largeGap : smallGap, ")");
  var inactiveWidthCalc = "calc(".concat(inactiveSize, " + ").concat(props.$vertical ? smallGap : largeGap, ")");
  if (props.$current) {
    return css(["height:", ";width:", ";"], props.$controlled ? "max(24px, ".concat(activeHeightCalc, ")") : activeHeightCalc, props.$controlled ? "max(24px, ".concat(activeWidthCalc, ")") : activeWidthCalc);
  } else {
    return css(["height:", ";width:", ";"], props.$controlled ? "max(24px, ".concat(inactiveHeightCalc, ")") : inactiveHeightCalc, props.$controlled ? "max(24px, ".concat(inactiveWidthCalc, ")") : inactiveWidthCalc);
  }
}, function (props) {
  return props.$active ? props.$activeColor : props.$inactiveColor;
}, function (_ref2) {
  var $current = _ref2.$current,
    $activeSize = _ref2.$activeSize,
    $size = _ref2.$size;
  return css(["height:", ";width:", ";transform:translate(-50%,-50%) scale(", ");"], px2rem($activeSize), px2rem($activeSize), $current ? 1 : Number($size) / Number($activeSize));
}, styles.transition.timing.slowest, styles.transition.timing.slowest, styles.transition["function"].base);
var visuallyHidden = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__visuallyHidden",
  componentId: "sc-1boclke-1"
})(["position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);white-space:nowrap;"]);

export { dot, visuallyHidden };
